export default "__VITE_ASSET__BsxKJC36__"